import { FileExcelOutlined } from '@ant-design/icons';
import { InFilter } from '@dofleini/query-builder';
import { Button } from 'antd';
import fileDownload from 'js-file-download';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useFilter } from '@/contexts/FilterContext';
import { useResponsive } from '@/contexts/ResponsiveContext';
import { useTableGrid } from '@/contexts/tableGridContact';
import useAlerts from '@/hooks/useAlerts';

export const ExportComponent = ({
  errorMessage,
  icon,
  params,
  title,
  documentTitle,
  format,
  service,
  translation
}) => {
  const { t } = useTranslation(translation || 'common');
  const { filter } = useFilter();
  const { isMobile } = useResponsive();
  const { selectedKeys } = useTableGrid();
  const { mutateAsync, isLoading: exportIsLoading } = useMutation(service);
  const { putErrorCode } = useAlerts();
  
  const existSelection = useMemo(() => !isEmpty(selectedKeys), [selectedKeys]);
  
  const handleExport = useCallback(async () => {
    try {
      const { data } = await mutateAsync({
        ...params,
        filters: existSelection ? new InFilter({ field: '_id', value: selectedKeys }) : filter
      });
      const name = `${documentTitle}-${moment().format('DD-MM-YYYY').toString()}${format}`;
      
      if (data) {
        fileDownload(data, name);
      }
    } catch (e) {
      putErrorCode(e || errorMessage);
    }
  }, [mutateAsync, params, existSelection, selectedKeys, filter, documentTitle, format, putErrorCode, errorMessage]);
  
  return <div>
    {!isMobile ? (
      <Button icon={icon ? icon : <FileExcelOutlined/>} loading={exportIsLoading} onClick={handleExport}>
        {t(title, { value: existSelection ? `(${selectedKeys?.length})` : '' })}
      </Button>
    ) : (
      <Button icon={icon ? icon : <FileExcelOutlined/>} loading={exportIsLoading} onClick={handleExport}/>
    )}
  </div>;
};

export default memo(ExportComponent);

ExportComponent.propTypes = {
  documentTitle: PropTypes.string,
  errorMessage: PropTypes.string,
  format: PropTypes.string,
  service: PropTypes.any,
  translation: PropTypes.string,
  params: PropTypes.any,
  icon: PropTypes.any,
  title: PropTypes.string
};

export const renderUserExtraActions = (errorMessage, title, documentTitle, format, service) => {
  return (
    <ExportComponent errorMessage={errorMessage} title={title}
      documentTitle={documentTitle} format={format}
      service={service}/>
  );
};
